const getFirstHeaderValue = (value: string | string[] | undefined): string => {
  if (!value) {
    return '';
  }
  return Array.isArray(value) ? value[0] : value;
};

export const getHeaderValue = ({
  headers,
  name,
}: {
  headers: Record<string, string | string[]>;
  name: string;
}): string => {
  const header = Object.entries(headers).find(
    ([key]) => key.toLowerCase() === name.toLowerCase(),
  );
  return getFirstHeaderValue(header?.[1]).trim();
};

export const isAbsoluteHttpUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
};

export const resolveReplayUrl = ({
  url,
  headers,
}: {
  url: string;
  headers: Record<string, string | string[]>;
}): string => {
  if (isAbsoluteHttpUrl(url)) {
    return url;
  }

  const host =
    getHeaderValue({ headers, name: 'host' }) ||
    getHeaderValue({ headers, name: ':authority' });
  if (!host) {
    return url;
  }

  const forwardedProto = getHeaderValue({
    headers,
    name: 'x-forwarded-proto',
  })
    .split(',')[0]
    .trim();
  const scheme =
    getHeaderValue({ headers, name: ':scheme' }) || forwardedProto || 'https';
  const path = url.startsWith('/') ? url : `/${url.replace(/^\/+/, '')}`;

  return `${scheme.replace(/:$/, '')}://${host}${path}`;
};
